import { BehaviorSubject } from 'rxjs'
import { Injectable } from '@angular/core'

@Injectable()
export class HeaderService {
    headerTitle = new BehaviorSubject<string>('')
    headerSubtitle = new BehaviorSubject<string>('')
}
